import BasicContentFullWidthEmbed from './BasicContentFullWidthEmbed';

export { type BasicContentFullWidthEmbedProps } from './BasicContentFullWidthEmbed';
export default BasicContentFullWidthEmbed;
